{
  "blocks": [
    {
      "id": "module-male-fertility-baseline",
      "kind": "module",
      "tags": ["his", "assessment", "testing", "sperm"],
      "title": "Fertility Baseline (His)",
      "subtitle": "Semen analysis to establish your starting numbers",
      "icon": "🔬",
      "body": {
        "duration": "1 week",
        "category": "assessment",
        "forWhom": "him",
        "includes": [
          "Complete semen analysis (count, motility, morphology, volume)",
          "2–5 days abstinence guidance before sample",
          "Results interpretation with a fertility specialist"
        ],
        "trackableMarkers": [
          {
            "name": "Sperm count",
            "expectedToChange": true,
            "expectation": "Baseline count in millions/mL. Responds meaningfully to lifestyle changes and supplements over 90 days.",
            "retestInterval": "90 days"
          },
          {
            "name": "Motility",
            "expectedToChange": true,
            "expectation": "Percentage of sperm swimming progressively. Often the first parameter to improve with intervention.",
            "retestInterval": "90 days"
          },
          {
            "name": "Morphology",
            "expectedToChange": true,
            "expectation": "Percentage of normal forms (strict Kruger criteria). Least responsive to intervention, but can shift modestly.",
            "retestInterval": "90 days"
          }
        ],
        "priceRange": {
          "low": 75,
          "high": 200
        },
        "currency": "USD",
        "status": "coming-soon",
        "steps": [
          {
            "title": "Abstinence window",
            "description": "2–5 days of abstinence before your sample for standardized results."
          },
          {
            "title": "Sample collection",
            "description": "At a lab or at-home kit. Results typically available within 2–3 business days."
          },
          {
            "title": "Results review",
            "description": "Understand your count, motility, and morphology (and what they mean for your options)."
          }
        ]
      },
      "sources": [
        {
          "title": "WHO laboratory manual for the examination of human semen",
          "journal": "WHO",
          "year": 2021,
          "evidenceLevel": "expert-opinion"
        }
      ]
    }
  ],
  "relationships": [],
  "localeVariants": []
}
